module.exports = __webpack_public_path__ + "assets/img/block-9a73eed3.png";